import React, { type ComponentType } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ProjectHeader } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/project-header/main.tsx';
import { addChunkLoadErrorAnalyticsAttribute } from '@atlassian/jira-onboarding-core/src/utils/chunk-error-logging/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { lazy } from '@atlassian/react-loosely-lazy';
import { PACKAGE_NAME } from '../common/constants.tsx';
import type { ProjectHeaderProps } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyInlineConfigurableProjectHeader = lazy<ComponentType<ProjectHeaderProps>>(
	() =>
		import(/* webpackChunkName: "async-inline-configurable-project-header" */ './index').then(
			(exportedModule) => exportedModule.InlineConfigurableProjectHeader,
		),
	{ ssr: false },
);

export const InlineConfigurableProjectHeaderAsync = (props: ProjectHeaderProps) => (
	<JSErrorBoundary
		id="inlineNameEditor"
		packageName={PACKAGE_NAME}
		teamName="jlove-makkuro"
		fallback="unmount"
		attributes={addChunkLoadErrorAnalyticsAttribute}
	>
		<Placeholder name="side-nav-inline-config-project" fallback={<ProjectHeader {...props} />}>
			<ContextualAnalyticsData attributes={{ subNamespaces: 'inlineConfigProjectHeader' }}>
				<LazyInlineConfigurableProjectHeader {...props} />
			</ContextualAnalyticsData>
		</Placeholder>
	</JSErrorBoundary>
);
